import React, {useState, useEffect} from "react";
import Gameplay from "./Gameplay";
import { Router, Route, Routes, Navigate } from "react-router-dom";
import Share from "./components/Share";
import { library } from '@fortawesome/fontawesome-svg-core'
import { faShare, faEnvelope, faTimes, faArrowsRotate, faArrowRight, faArrowDown, faSyncAlt, faArrowRightArrowLeft, faAward, faLightbulb  } from '@fortawesome/free-solid-svg-icons'
import { faXTwitter, } from '@fortawesome/free-brands-svg-icons'


library.add(faShare, faXTwitter, faEnvelope, faTimes, faArrowsRotate, faArrowRight, faArrowDown, faSyncAlt,faArrowRightArrowLeft, faAward, faLightbulb)


function App() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Function to check the viewport width
    const handleResize = () => {
      const mobileBreakpoint = 768; // Adjust based on your design breakpoint 
      setIsMobile(window.innerWidth <= mobileBreakpoint);
    };

    // Initial check
    handleResize();

    // Listen for window resize events
    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="App">
        <Routes>
          <Route path="/share" element={<Share isMobile={isMobile}/>} />
          <Route path="/terms-of-service" element={<Gameplay isMobile={isMobile} />} />
          <Route path="/privacy-policy" element={<Gameplay isMobile={isMobile} />} />
          <Route path="/" element={<Gameplay isMobile={isMobile} />}/>

        </Routes>
    </div>
  );
}

export default App;